// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"9edfce2e","230":"d6cc6cff"}[chunkId] + ".chunk.js";
};